import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

import Message from "./message";
import Agreements from "./join/agreements";
import DaumPostcode from "react-daum-postcode";

import { JoinFormContainer, PageContainer } from "./styled/common";
import { AddrSearchModal } from "../../mypage/scheduler/component/styled/calendarEntry";

import { useModal } from "../../../hooks/useModal";

const BusinessJoinForm = ({ url: shopUrl = "", homepageInfo = null }) => {
  const navigate = useNavigate();
  const [toggleLegalInfo, setToggleLegalInfo] = useState(false);
  const [formData, setFormData] = useState({
    bizrno: "",
    cmpnyNm: "",
    rprNm: "",
    email: "",
    telno: "",
    name: "",
    password: "",
    confirmPassword: "",
    username: "",
    adres: "",
    dtlAdres: "",
  });
  const [isDuplicate, setIsDuplicate] = useState({
    username: false,
    telno: false,
    bizrno: false,
    email: false,
  });
  const [agreements, setAgreements] = useState({
    selectall: false,
    serviceTerms: false,
    privacyPolicy: false,
    marketing: false,
  });
  const [showPostCode, setShowPostCode] = useState(false);

  const { modal, openModal, closeModal } = useModal();

  const openPostCode = () => setShowPostCode(true);
  const closePostCode = () => setShowPostCode(false);

  const changeInput = (e) => {
    const { name, checked, type } = e.target;

    if (!name) return;

    if (type === "checkbox") {
      if (name === "selectall") {
        setAgreements({
          selectall: checked,
          serviceTerms: checked,
          privacyPolicy: checked,
          marketing: checked,
        });
      } else {
        setAgreements((prev) => {
          const updated = { ...prev, [name]: checked };
          const allChecked = updated.serviceTerms && updated.privacyPolicy && updated.marketing;

          return { ...updated, selectall: allChecked };
        });
      }
    } else {
      const { value } = e.target;
      setFormData((data) => ({ ...data, [name]: value }));

      if (isDuplicate.hasOwnProperty(name) && isDuplicate[name]) {
        setIsDuplicate((state) => ({ ...state, [name]: false }));
      }
    }
  };

  // 아이디, 휴대폰 번호, 사업자 번호 중복검사
  const alreadyExists = async (type) => {
    const types = {
      username: {
        url: "/api/isExistId",
        body: { username: formData.username },
        checkDuplicate: (data) => data.message !== "isExist",
        displayName: "아이디",
      },
      telno: {
        url: "/api/duplMoblphonNo",
        body: { moblphonNo: formData.telno },
        checkDuplicate: (data) => data.success,
        displayName: "휴대폰 번호",
      },
      bizrno: {
        url: "/api/duplBizrNo",
        body: { bizrno: formData.bizrno },
        checkDuplicate: (data) => data.message === "isNotExist",
        displayName: "사업자 번호",
      },
      email: {
        url: "/api/duplEmail",
        body: { email: formData.email },
        checkDuplicate: (data) => data.success,
        displayName: "이메일",
      },
    };

    try {
      const { url, body, checkDuplicate, displayName } = types[type];
      const res = await axios.post(url, body);

      if (!checkDuplicate(res.data)) {
        toast.error(`이미 사용 중인 ${displayName}입니다.`);
        setIsDuplicate((data) => ({ ...data, [type]: false }));
      } else {
        toast.success(`사용 가능한 ${displayName}입니다.`);
        setIsDuplicate((data) => ({ ...data, [type]: true }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validationCheck = (type) => {
    const types = {
      telno: {
        reg: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
        msg: "유효하지 않은 휴대폰 번호입니다.",
      },
      username: {
        reg: /^[a-zA-Z0-9]{6,15}$/,
        msg: "아이디는 영문과 숫자를 포함한 6~15자리여야 합니다.",
      },
      bizrno: {
        reg: /^[0-9]{10}$/,
        msg: "유효하지 않은 사업자 번호입니다.",
      },
      email: {
        reg: /([A-Za-z0-9_.-]+(\.[A-Za-z0-9_.-]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/,
        msg: "유효하지 않은 이메일 주소입니다.",
      },
    };

    const { reg, msg } = types[type];
    const inputValue = formData[type] || undefined;

    if (inputValue && reg.test(inputValue)) {
      alreadyExists(type);
    } else {
      toast.error(msg);
    }
  };

  // 전체 체크
  const validateFormData = () => {
    const fieldLabels = {
      username: "아이디",
      password: "비밀번호",
      confirmPassword: "비밀번호 확인",
      name: "고객명",
      telno: "휴대폰 번호",
      email: "이메일",
      cmpnyNm: "회사 이름",
      rprNm: "대표자 이름",
    };

    for (let key in fieldLabels) {
      if (textNotExist(formData[key])) {
        const label = fieldLabels[key] || "";
        toast.error(`${chooseParticle(label, "을를")} 입력해주세요.`);
        return;
      }
    }

    for (let key in isDuplicate) {
      if (key === "bizrno") {
        if (!isDuplicate.bizrno && formData.bizrno) {
          toast.error(`사업자 번호 중복 확인을 해주세요.`);
          return;
        }
      } else {
        if (!isDuplicate[key]) {
          const label = fieldLabels[key] || "";
          toast.error(`${label} 중복 확인을 해주세요.`);
          return;
        }
      }
    }

    const regPassword = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[#?!@$ %^&*-]).{8,}$/;
    if (!regPassword.test(formData.password)) {
      toast.error("비밀번호 양식이 올바르지 않습니다.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!agreements.privacyPolicy || !agreements.privacyPolicy) {
      toast.error("모든 필수 약관에 동의해야 회원가입이 가능합니다.");
      return;
    }
    const regKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    if (regKor.test(formData.email)) {
      toast.error("이메일 양식이 일치하지 않습니다.");
      return;
    }

    openModal({
      isOpen: true,
      type: "confirmation",
      title: "회원가입",
      message: ["입력하신 정보로", "회원가입을 진행하시겠습니까?"],
      handleConfirm: () => onSubmit(),
      handleCancel: () => closeModal(),
    });
  };

  const onSubmit = async () => {
    let form = { ...formData };
    if (formData.adres) {
      form = { ...form, ...(await searchAddress(formData.adres)) };
    }

    await createCmpny(form);
  };

  const createCmpny = async (data) => {
    const url = "/api/cmpny";
    const body = {
      rprNm: data.rprNm,
      cmpnyNm: data.cmpnyNm,
      useYn: "Y",
      bizrno: data.bizrno,
      adres: data.adres,
      dtlAdres: data.dtlAdres,
      createMberId: data.username,
      updateMberId: data.username,
    };

    if (data.latitude) {
      body.latitude = data.latitude;
    }
    if (data.longitude) {
      body.longitude = data.longitude;
    }

    const res = await axios.put(url, body);

    if (res.data) {
      const cmpnyNo = res.data.rtnModel.cmpnyNo;
      const bizData = { ...data, cmpnyNo };

      await createMber(bizData);
    }
  };

  const createMber = async (data) => {
    const url = "/api/mber";
    const body = {
      cmpnyNo: data.cmpnyNo,
      username: data.username,
      password: data.password,
      mberNm: data.name,
      moblphonNo: data.telno,
      email: data.email,
      createMberId: data.username,
      updateMberId: data.username,
      rgsCl: "MBRS02",
      delYn: "N",
    };

    const res = await axios.put(url, body);

    if (res.data.success) {
      const userData = {
        ...res.data.rtnModel,
        cmpnyNo: data.cmpnyNo,
      };
      await updateCmpnyMber(userData);
    }
  };

  // 회사 멤버 업데이트
  const updateCmpnyMber = async (data) => {
    const url = "/api/cmpnyMber";
    const body = {
      cmpnyNo: data.cmpnyNo,
      mberNo: data.mberNo,
      mberNm: data.mberNm,
      mberTel: data.moblphonNo,
      auth: "ADMIN",
      isWorking: true,
      isDeleted: false,
      userId: data.username,
      createMberId: data.username,
      updateMberId: data.username,
    };

    try {
      const res = await axios.put(url, body);
      if (res.status === 200) {
        console.log(res);
        toast.success("회원 가입이 완료되었습니다.", { toastId: "no-access" });
        navigate(shopUrl ? `/shop/${shopUrl}/login` : "/login");
      }
    } catch (error) {
      toast.error("에러가 발생하였습니다. 잠시 후 다시 시도해주세요.");
    }
  };

  // 카카오 주소
  const userAddress = (data) => {
    const extraAddress = [data.bname, data.buildingName].filter(Boolean).join(", ");
    const fullAddress = data.address + (extraAddress ? ` (${extraAddress})` : "");

    setFormData((data) => {
      const updated = { ...data, adres: fullAddress };
      return updated;
    });

    closePostCode();
  };

  // 위도 경도 찾기
  const searchAddress = async (address) => {
    try {
      const url = "/api/getCoordinates";
      const body = { address };
      const res = await axios.post(url, body);
      const data = res?.data?.documents;

      if (res.status === 200 && data && data.length > 0) {
        return { latitude: data[0].y, longitude: data[0].x };
      } else {
        throw new Error("No address");
      }
    } catch (error) {
      return null;
    }
  };

  const fields = [
    {
      key: "username",
      label: "아이디",
      isDuplicate: true,
      inputType: "text",
      required: true,
      placeholder: "아이디 (영문 + 숫자, 6~15자리)",
      value: formData.username,
      tabIndex: 1,
    },
    {
      key: "password",
      label: "비밀번호",
      isDuplicate: false,
      inputType: "password",
      required: true,
      placeholder: "비밀번호 (영문 + 숫자 + 특수문자, 8자리이상)",
      value: formData.password,
      tabIndex: 3,
    },
    {
      key: "confirmPassword",
      label: "비밀번호 확인",
      isDuplicate: false,
      inputType: "password",
      required: true,
      placeholder: "비밀번호 확인",
      value: formData.confirmPassword,
      tabIndex: 4,
    },
    {
      key: "name",
      label: "고객명",
      isDuplicate: false,
      inputType: "text",
      required: true,
      placeholder: "고객명을 입력하세요",
      value: formData.name,
      tabIndex: 5,
    },
    {
      key: "telno",
      label: "고객 휴대전화",
      isDuplicate: true,
      inputType: "text",
      required: true,
      placeholder: "휴대폰 번호(-없이 입력)",
      value: formData.telno,
      tabIndex: 6,
    },
    {
      key: "email",
      label: "이메일",
      isDuplicate: true,
      inputType: "text",
      required: true,
      placeholder: "이메일",
      value: formData.email,
      tabIndex: 8,
    },
  ];

  const companyFields = [
    {
      key: "cmpnyNm",
      label: "회사명",
      inputType: "text",
      required: true,
      placeholder: "회사명을 입력하세요",
      value: formData.cmpnyNm,
      tabIndex: 9,
    },
    {
      key: "rprNm",
      label: "대표자 이름",
      inputType: "text",
      required: true,
      placeholder: "대표자 이름을 입력하세요",
      value: formData.rprNm,
      tabIndex: 10,
    },
    {
      key: "bizrno",
      label: "사업자등록번호",
      inputType: "text",
      required: false,
      placeholder: "사업자등록번호(숫자만 입력)",
      value: formData.bizrno,
      tabIndex: 11,
      isDuplicate: true,
      duplicateButtonTabIndex: 12,
    },
    {
      key: "adres",
      label: "주소",
      inputType: "text",
      required: true,
      placeholder: "주소찾기 버튼을 눌러주세요",
      value: formData.adres,
      tabIndex: 13,
      readOnly: true,
      hasButton: true,
      buttonText: "주소찾기",
      buttonAction: openPostCode,
      buttonTabIndex: 14,
    },
    {
      key: "dtlAdres",
      label: "상세주소",
      inputType: "text",
      required: false,
      placeholder: "상세주소를입력하세요",
      value: formData.dtlAdres,
      tabIndex: 15,
    },
  ];

  return (
    <PageContainer>
      <Message url={shopUrl} homepageInfo={homepageInfo} />
      <JoinFormContainer>
        <div className="sectionInfo">
          <span>계정정보</span>
          <span> ※ 모두 필수 입력 정보입니다.</span>
        </div>
        <ul className="fields">
          {fields.map((field) => (
            <li key={field.key}>
              <div className="tit">
                {field.label}
                {field.required && <em className="point"></em>}
              </div>
              <div className={`cont ${field.isDuplicate ? "duplicate" : ""}`}>
                <input
                  type={field.inputType}
                  name={field.key}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={(e) => changeInput(e)}
                  tabIndex={field.tabIndex}
                />
                {field.isDuplicate && (
                  <button
                    type="button"
                    onClick={() => validationCheck(field.key)}
                    tabIndex={field.tabIndex + 1}>
                    <span>중복 확인</span>
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
        <div className="sectionInfo">
          <span>회사정보</span>
          <span> ※ '*'는 필수 입력 정보입니다. 반드시 정확히 입력해주세요.</span>
        </div>
        <ul className="fields">
          {companyFields.map((field) => (
            <li key={field.key}>
              <div className="tit">
                <strong className="tit">
                  {field.label}
                  {field.required && <em className="point"></em>}
                </strong>
              </div>
              <div className={`cont ${field.isDuplicate || field.hasButton ? "duplicate" : ""}`}>
                <input
                  type={field.inputType}
                  name={field.key}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={(e) => changeInput(e)}
                  tabIndex={field.tabIndex}
                  readOnly={field.readOnly || false}
                />
                {field.isDuplicate && (
                  <button
                    type="button"
                    onClick={() => validationCheck(field.key)}
                    tabIndex={field.duplicateButtonTabIndex}>
                    <span>중복 확인</span>
                  </button>
                )}
                {field.hasButton && (
                  <button
                    type="button"
                    onClick={field.buttonAction}
                    tabIndex={field.buttonTabIndex}>
                    <span>{field.buttonText}</span>
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
        <Agreements
          agreements={agreements}
          toggleLegalInfo={toggleLegalInfo}
          setToggleLegalInfo={setToggleLegalInfo}
          changeInput={changeInput}
        />
        <button onClick={validateFormData} className="submit">
          완료
        </button>
        {showPostCode && (
          <AddrSearchModal
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closePostCode();
              }
            }}>
            <div className="modalContent">
              <DaumPostcode onComplete={userAddress} />
              <button onClick={closePostCode}>닫기</button>
            </div>
          </AddrSearchModal>
        )}
        {modal}
      </JoinFormContainer>
    </PageContainer>
  );
};

export default BusinessJoinForm;
